module.exports = __webpack_public_path__ + "img/incentives-and-rebates-card.86aec308.png";